module.exports = __webpack_public_path__ + "static/img/803_phase_function_Paper_PointsHejduk_Prediction.2dff834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/803_phase_function_Paper_PointsHejduk_Prediction.png
// module id = RR2S
// module chunks = 0